import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FieldItem } from 'src/app/models/common/field-item';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseComponent } from 'src/app/system-common/base/base.component';

@Component({
  selector: '',
  template: '',
})
export class AgentHierarchySupervisorHandler extends BaseComponent<AgentService> implements OnChanges {
  @Input() public service: any;
  @Input() public model: any;
  public searchName: string;
  public isDisable;
  public item: any;
  public isparentAgentIdSearchDisplayed: boolean;
  public parentAgentIdSelectedOption: any;
  protected parentAgentIdFieldItems: FieldItem[];

  constructor(public agentService: AgentService, public router: Router, public settingService: SettingService) {
    super(agentService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'ONHOLD' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED'
    ) {
      this.isDisable = true;
    } else this.isDisable = false;
    // this.searchName = 'SearchSupervisor';
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['model'] && changes['model'].currentValue) {
      this.model = changes['model'].currentValue;
    }
  }

  protected getMoreOptionList(): any[] {
    return [];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Agent';
    return header;
  }

  public onparentAgentIdSearchClick(field: FieldItem) {
    this.parentAgentIdSelectedOption = undefined;
    this.isparentAgentIdSearchDisplayed = true;
    setTimeout(() => {
      let id = this.model == undefined ? field.model.guid : this.model.guid;
      this.openModal('parentAgentIdSearch' + id);
    }, 50);
  }

  public onparentAgentIdSearchSelected(selectedOption) {
    console.log('this.model', this.model);

    this.parentAgentIdSelectedOption = selectedOption;
    // this.service.setModelFieldValue(this.model, 'branchId', selectedOption['branchId']);
    this.service.setModelFieldValue(this.model, 'parentAgencyId', selectedOption['parentAgencyId']);
    // this.service.setModelFieldValue(this.model, 'agentName', selectedOption['agentName']);
    this.service.setModelFieldValue(this.model, 'parentAgentId', selectedOption['agentId']);
    this.service.setModelFieldValue(this.model, 'channelCd', selectedOption['channelCd']);
    this.service.setModelFieldValue(this.model, 'agentSegmentation1', null);
    this.service.setModelFieldValue(this.model, 'agentSegmentation2', null);
  }

  public onparentAgentIdFieldsCreated(fieldItemArray: FieldItem[]) {
    if (this.parentAgentIdFieldItems != undefined) {
      fieldItemArray.filter((item) => {
        let index = this.parentAgentIdFieldItems.findIndex((field: FieldItem) => field.fieldCd == item.fieldCd);
        let isAvailable = this.parentAgentIdFieldItems.find((field: FieldItem) => field.fieldCd == item.fieldCd);
        if (!isAvailable) this.parentAgentIdFieldItems.push(item);
        if (isAvailable) this.parentAgentIdFieldItems[index] = item;
      });
    } else {
      this.parentAgentIdFieldItems = fieldItemArray;
    }
  }

  ngOnDestroy() {
    this.isparentAgentIdSearchDisplayed = false;
  }
}
